import { ObservableRegistry } from "./observable-registry";

export interface GenieContextEntry {
  key: string;
  description: string;
  value: unknown;
}

class GenieContextRegistry extends ObservableRegistry<
  GenieContextEntry,
  GenieContextEntry
> {
  constructor() {
    super((entry) => entry);
  }

  set(key: string, description: string, value: unknown): () => void {
    return this.upsert(key, { key, description, value });
  }

  delete(key: string): void {
    this.remove(key);
  }
}

export const genieContext = new GenieContextRegistry();
